import { TooltipCode } from 'areas/shared/consts';

const BusinessTax1 = {
    code: "BusinessTax1",
    description: "Previous Year Business Federal Tax Return or IRS Extension Acceptance Letter",
    notApplicableLabel: "Not applicable to my Business",
    tooltipCode: TooltipCode.TAX.BL
};
const BusinessTax2 = {
    code: "BusinessTax2",
    description: "Prior to Previous Year Business Federal Tax Return or IRS Extension Acceptance Letter",
    notApplicableLabel: "Not applicable to my Business",
    tooltipCode: TooltipCode.TAX.PBL
};
const PersonalTax1 = {
    code: "PersonalTax1",
    description: "Previous Year Personal Federal Tax Return or IRS Extension Acceptance Letter",
    notApplicableLabel: "Not applicable",
    tooltipCode: TooltipCode.TAX.PL
};
const PersonalTax2 = {
    code: "PersonalTax2",
    description: "Prior to Previous Year Personal Federal Tax Return or IRS Extension Acceptance Letter",
    notApplicableLabel: "Not applicable",
    tooltipCode: TooltipCode.TAX.PPL
};

export default {
    BusinessTax1,
    BusinessTax2,
    PersonalTax1,
    PersonalTax2
};


// WEBPACK FOOTER //
// ./src/areas/admin/certification/certificationInfo/taxInfo/UploadsConfig.js